@if (surveyEditorService.surveyEditor$().activeQuestion; as activeQuestion) {
  <div>
    <empathy-choices-form [allowOther]="true" [allowNone]="true"></empathy-choices-form>
    <empathy-rating-values-form [isRankSort]="true" [maxValue]="activeQuestion.get('options').value.length"></empathy-rating-values-form>
    <form [formGroup]="activeQuestion">
      <div class="question-form__array">
        <div class="question-form__rating-scale">
          <div class="editor-question-form__input rating-scale__input-container">
            <span class="label">Minimum Rank</span>
            <mat-form-field appearance="outline">
              <button
                matPrefix
                mat-icon-button
                title="decrease scale"
                class="decrease"
                [disabled]="activeQuestion.get('minRank').value <= 1"
                (click)="onDecreaseScale()"
              >
                <fa-icon [icon]="faMinus"></fa-icon>
              </button>
              <input
                matInput
                type="number"
                min="1"
                step="1"
                formControlName="minRank"
                class="rating-scale__input"
                editorAutoFocus
                autocomplete="off"
                (blur)="onRoundNumber()"
                (input)="onMinimumRatingInputChange($event)"
              />
              <button
                matSuffix
                mat-icon-button
                title="increase scale"
                class="increase"
                [disabled]="
                  activeQuestion.get('minRank').value >=
                  (activeQuestion.get('ratingType').value === ratingType.numeric
                    ? activeQuestion.get('ratingScale').value
                    : activeQuestion.get('ranks').value.length)
                "
                (click)="onIncreaseScale()"
              >
                <fa-icon [icon]="faPlus"></fa-icon>
              </button>
            </mat-form-field>
          </div>
        </div>
        <div class="editor-question-form__input">
          <span class="label">Feedback Message</span>
          <mat-form-field appearance="outline">
            <input matInput formControlName="feedbackMessage" editorAutoFocus block="nearest" autocomplete="off" />
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>
}
